import { ObjectLiteral } from '@prophecy/interfaces/generic';
import queryString from 'query-string';

import { ShareDetails } from '../data/apis/types';

const SHARE_WINDOW_KEY = '__prophecy-share-token';
export const SHARE_TOKEN_KEY = 'share-token';

const windowStore = window as ObjectLiteral;

interface ShareToken {
  key: string;
  shareDetails?: ShareDetails['shareDetails'];
  hasDirectAccess?: boolean;
  loggedInUserId?: string;
  get: () => string | null;
  set: (value: string) => void;
  delete: () => void;
}

export const shareToken: ShareToken = {
  key: SHARE_TOKEN_KEY,
  get() {
    return windowStore[SHARE_WINDOW_KEY] as string;
  },
  set(value: string) {
    windowStore[SHARE_WINDOW_KEY] = value;
  },
  delete() {
    windowStore[SHARE_WINDOW_KEY] = null;
  }
};

export function addShareTokenQuery(url: string) {
  const token = shareToken.get();
  if (!token) return url;
  return queryString.stringifyUrl({ url, query: { [SHARE_TOKEN_KEY]: token } });
}

export const isShareMode = () => {
  return Boolean(shareToken.get());
};

const SNAPSHOT_ID_KEY = 'snapshotId';
const SNAPSHOT_TYPE_KEY = 'snapshotType';

export function addSnapshotQuery(url: string) {
  const params = new URLSearchParams(window.location.search);
  const snapshotMode = params.get('snapshotMode');
  const shareId = params.get('shareId');
  if (snapshotMode !== 'true' || !shareId) return url;
  return queryString.stringifyUrl({
    url,
    query: { [SNAPSHOT_ID_KEY]: shareId, [SNAPSHOT_TYPE_KEY]: 'publicShare' }
  });
}
